module.exports = __webpack_public_path__ + "img/videogallery-icon.1ff6d591.png";